import ProductPreview from "./ProductPreview";

// Only the completed, owner-approved overview crop. No attendance placeholder.
const screens = [{
  name: "overview",
  title: "Pupil records, in context",
  description: "A rectangular selection of four synthetic pupil records, with the pupil heading, filters and table headings retained. The demonstration banner, legal-name caveats, IDs and current statuses are unchanged.",
  alt: "Synthetic KedByte Quill pupil list: heading and filters, then four complete Ahmedabad demonstration-campus rows with names, IDs, legal-name caveats, classes, sections and Current statuses. The NOT A REAL SCHOOL banner is retained.",
  width: 2210, height: 1014, fullOnly: true,
  caption: "Cropped development preview · Sample data.",
  screenLabel: "KedByte Quill / Pupil overview",
  linkLabel: "View pupil overview at full resolution",
  viewerTitle: "Pupil overview preview",
  viewerNote: "Synthetic records from a development build, not a real school.",
  note: "Four rows selected from the captured ten-row list. The qualifications below summarise its Data notes; no interface content has been reconstructed.",
  qualifications: [
    "Admission numbers: this captured build has no admission-number field. The record IDs shown under names are not school admission numbers.",
    "† Campus: a recorded campus name is shown where available; otherwise the campus identifier is shown.",
    "‡ Status: the list excludes ended enrolments. It can show Current or Not started; all four selected records are Current.",
  ],
}];

export default function QuillPreview() {
  return <ProductPreview product="quill" root="/images/quill-preview-20260923"
    heading="A closer look at pupil records."
    introduction="A genuine interface capture from the retained synthetic-data development build. This preview is not evidence of production readiness, general availability, security acceptance or regulatory compliance."
    screens={screens} />;
}
